import { FlexCol, FlexRow } from '@/components/ui/flex';
import { Text } from '@/components/ui/text';
import { cn } from '@/utils/classUtils';
import { CornerDownRight } from 'lucide-react';
import { type FC } from 'react';

interface FollowUpQuestionsProps {
  questions: string[];
  onQuestionClick: (question: string) => void;
}

export const FollowUpQuestions: FC<FollowUpQuestionsProps> = ({
  questions,
  onQuestionClick,
}) => {
  if (!questions || questions.length === 0) {
    return null;
  }

  return (
    <FlexCol gap="2" className="mt-4">
      {/* Header */}
      <Text className="text-xl font-semibold text-neutral-900 tracking-tight">
        Follow-up questions
      </Text>

      {/* Questions List */}
      <FlexCol>
        {questions.map((question, index) => (
          <FlexRow
            key={index}
            alignItems="start"
            gap="1"
            className={cn(
              'cursor-pointer py-2 transition-colors rounded-lg',
              'hover:bg-neutral-50 active:bg-neutral-100'
            )}
            onClick={() => onQuestionClick(question)}
          >
            <div className="flex items-center justify-center min-w-8 min-h-8 rounded-lg shrink-0">
              <CornerDownRight className="w-4 h-4 text-neutral-900" />
            </div>
            <Text className="text-base text-neutral-900 leading-relaxed py-1">
              {question}
            </Text>
          </FlexRow>
        ))}
      </FlexCol>
    </FlexCol>
  );
};
